import { t } from 'i18next';
import { getMenuItemsForRole } from './pages';
import { ReactComponent as IconHome } from 'assets/images/icons/icon_home.svg';

// ===========================|| MENU ITEMS ||=========================== //
const getMenuItems = (role) => {
    const pages = getMenuItemsForRole(role);
    const title = t('pages.home');

    const icons = {
        IconHome
    };

    const dashboard = {
        id: 'dashboard',
        type: 'group',
        children: [
            {
                title: title,
                key: 'dashboard.inicio',
                type: 'item',
                url: '/dashboard/default',
                icon: icons.IconHome,
                breadcrumbs: false
            },
            {
                type: 'divider'
            }
        ]
    };

    {
        /**return {
            items: [dashboard, ...pages]
        };**/
        return {
            items: [...pages]
        };
    }
};

export default getMenuItems;
